/* SALITRE — hero-logo-intro.js: el logo grande del hero viaja hasta la cabecera al pasar el mismo umbral de scroll que activa el header sólido */
(function () {
  'use strict';

  var SCROLL_THRESHOLD = 40;

  var heroLogo = document.querySelector('[data-hero-logo]');
  var headerLogoImg = document.querySelector('[data-header-logo] .site-header__logo-img');
  var headerLogo = document.querySelector('[data-header-logo]');
  if (!heroLogo || !headerLogo || !headerLogoImg) return;

  var done = false;

  function dockToHeader() {
    if (done) return;
    done = true;

    var target = headerLogoImg.getBoundingClientRect();
    var current = heroLogo.getBoundingClientRect();
    var scale = target.width / current.width;
    var deltaX = (target.left + target.width / 2) - (current.left + current.width / 2);
    var deltaY = (target.top + target.height / 2) - (current.top + current.height / 2);

    heroLogo.style.transform =
      'translate(calc(-50% + ' + deltaX + 'px), calc(-50% + ' + deltaY + 'px)) scale(' + scale + ')';
    heroLogo.classList.add('is-docked');
    headerLogo.classList.remove('site-header__logo--intro-pending');

    setTimeout(function () {
      heroLogo.hidden = true;
    }, 650);
  }

  function onScroll() {
    if (window.scrollY > SCROLL_THRESHOLD) {
      window.removeEventListener('scroll', onScroll);
      dockToHeader();
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
})();
